<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>资料管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateMaterialDialog()">
          新增资料
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="materials"
      :items-per-page="pageSize"
      :page.sync="page"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      @update:page="handlePageChange"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showPreviewMaterial(item)">
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn small @click="showEditMaterialDialog(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-material-popup
      ref="createMaterialPopup"
      @create-material="refreshList"
    ></create-material-popup>
    <preview-material-popup
      ref="previewMaterialPopup"
    ></preview-material-popup>
    <edit-material-popup
    ref="editMaterialPopup"
    @update-material="refreshList"
    ></edit-material-popup>
  </v-container>
</template>

<script>
import { materialApi } from '@/api/material'
import PreviewMaterialPopup from '@/components/PreviewMaterialPopup.vue'
import EditMaterialPopup from '@/components/EditMaterialPopup.vue'
import CreateMaterialPopup from '@/components/CreateMaterialPopup.vue';

export default {
  components: {
    PreviewMaterialPopup,
    EditMaterialPopup,
    CreateMaterialPopup,
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "类别名称", value: "categoryName" },
        { text: "文件名", value: "filename" },
        { text: "操作", value: "actions", sortable: false }
      ],
      materials: [],
      page: 1,
      pageSize: 10,
      itemsPerPageOptions: [10,30,50,100],
      totalItems: 0,
    };
  },
  async created() {
    await this.fetchMaterials();
  },
  methods: {
    async fetchMaterials() {
      this.loading = true;
      try {
        const response = await materialApi.getMaterials(this.page, this.pageSize);
        this.materials = response.data.interviewDataList;
        this.totalItems = response.data.pageTotal * this.pageSize;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取资料列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handlePageChange() {
      this.fetchMaterials();
    },
    showCreateMaterialDialog() {
      this.$refs.createMaterialPopup.open();
    },
    showEditMaterialDialog(item) {
      this.$refs.editMaterialPopup.open(item);
    },
    showPreviewMaterial(item) {
      this.$refs.previewMaterialPopup.open(item.fileId);
    },
    refreshList() {
      this.fetchMaterials();
    },
  },
};
</script>
